import {CountryCode, Quote} from "../../api/models";
import React, {CSSProperties, useRef, useState} from "react";
import {Button, InputRef, Popover} from "antd";
import Utils from "../../util/util";
import StatesSelector from "../StatesSelector";
import {useQuoteContext} from "../../contexts/QuoteContext";


const StateSelectionPopover = (props:{
    readOnly?: boolean
    onChange?: (n: string | undefined) => void
    txtStyle?: CSSProperties
    btnStyle?: CSSProperties
}) => {

    const { quote } = useQuoteContext();

    const [isOpen, setIsOpen] = useState<boolean>(false);
    const txtStyle = {
        borderBottom: "1px solid black",
        ...props.txtStyle,
    };
    const [stateRegistration, setStateRegistration] = useState<string>();
    const inputRef = useRef<InputRef>(null);

    const handleOpen = () => {
        setStateRegistration( quote?.stateRegistration );
        setIsOpen(true);
    }
    const handleBlur = () => {
        setIsOpen(false);

        props.onChange?.(stateRegistration);
    }

    const handleChangeShipDate = (value: string | undefined) => {
        setStateRegistration(value);
    }

    //check if canada, next state name, then TBD
    const stateName = quote?.stateRegistration === "CAN" ? "Canada"
        : ( Utils.getState( CountryCode.US, quote?.stateRegistration )?.name || quote?.stateRegistration );

    const btnTitle = stateName || "Add State Registration";

    return <Popover
        open={isOpen}
        afterOpenChange={(open) => {
            if( open ) {
                inputRef.current?.focus();
            }
        }}
        content={<>
            <StatesSelector
                placeholder="Select State Registration"
                data-testid="stateRegistrationSelector"
                includeCanada={true}
                includeTbd={true}
                //@ts-ignore
                ref={inputRef}
                allowClear
                value={stateRegistration}
                onChange={handleChangeShipDate}
                onBlur={handleBlur}
            />
        </>}
    >
        {!props.readOnly
                ? <Button className="ghostBmButton" type="text" onClick={handleOpen}
                          data-testid="stateRegistrationSelectorPopover"
                          title={btnTitle}
                          style={{
                              ...props.btnStyle,
                              margin: 0,
                              padding: 0
                          }} >
                    <span style={txtStyle}>{btnTitle}</span>
                </Button>
                : btnTitle}
    </Popover>
}

export default StateSelectionPopover;
